import React, { useState, useCallback, useEffect, forwardRef } from "react";
import { FormLayout, TextField, Text, RangeSlider } from "@shopify/polaris";
import { HexColorPicker } from "react-colorful";

const BackgroundStyle = (props) => {
  const handleSelectChangeBackgroundColor = (newValue) => {
    props.handleSelectChangeBackgroundColor(newValue);
  };
  const handleChangeBackgroundOpacity = (newValue) => {
    props.handleChangeBackgroundOpacity(newValue);
  };
  const handleSelectChangeBackgroundGradientColor1 = (newValue) => {
    props.handleSelectChangeBackgroundGradientColor1(newValue);
  };
  const handleSelectChangeBackgroundGradientColor2 = (newValue) => {
    props.handleSelectChangeBackgroundGradientColor2(newValue);
  };
  const [clickedGradient, setClickedGradient] = useState("");
  return (
    <FormLayout>
      <Text variant="headingSm" as="h6">
        BACKGROUND STYLE
      </Text>
      <Text as="p" fontWeight="medium">
        Color
      </Text>
      <HexColorPicker
        color={
          props?.item?.background?.color ? props?.item?.background?.color : ""
        }
        onChange={handleSelectChangeBackgroundColor}
      />
      <TextField
        value={
          props?.item?.background?.color ? props?.item?.background?.color : ""
        }
        onChange={handleSelectChangeBackgroundColor}
      />
      <Text as="p" fontWeight="medium">
        Gradient Color
      </Text>
      <div className="rowDiv">
        <span
          className="dot grad1"
          id={clickedGradient === 1 ? "border" : ""}
          onClick={() => setClickedGradient(1)}
        ></span>
        <span
          className="dot grad2 ms-2"
          id={clickedGradient === 2 ? "border" : ""}
          onClick={() => setClickedGradient(2)}
        ></span>
        <span
          className="dot grad3 ms-2"
          id={clickedGradient === 3 ? "border" : ""}
          onClick={() => setClickedGradient(3)}
        ></span>
        <span
          className="dot grad4 ms-2"
          id={clickedGradient === 4 ? "border" : ""}
          onClick={() => setClickedGradient(4)}
        ></span>
        <span
          className="dot grad5 ms-2"
          id={clickedGradient === 5 ? "border" : ""}
          onClick={() => setClickedGradient(5)}
        ></span>
        <span
          className="dot grad6 ms-2"
          id={clickedGradient === 6 ? "border" : ""}
          onClick={() => setClickedGradient(6)}
        ></span>
      </div>

      <FormLayout.Group>
        <TextField
          label="Color 1"
          value={
            props?.item?.background?.gradientColor1
              ? props?.item?.background?.gradientColor1
              : ""
          }
          onChange={handleSelectChangeBackgroundGradientColor1}
        />
        <TextField
          label="Color 2"
          value={
            props?.item?.background?.gradientColor2
              ? props?.item?.background?.gradientColor2
              : ""
          }
          onChange={handleSelectChangeBackgroundGradientColor2}
        />
      </FormLayout.Group>
      <RangeSlider
        output
        label="Opacity Percentage"
        min={0}
        max={100}
        value={
          props?.item?.background?.opacity
            ? props?.item?.background?.opacity
            : ""
        }
        onChange={handleChangeBackgroundOpacity}
        suffix={
          <p
            style={{
              minWidth: "24px",
              textAlign: "right",
            }}
          >
            {props?.item?.background?.opacity
              ? props?.item?.background?.opacity
              : ""}
          </p>
        }
      />
    </FormLayout>
  );
};

export default BackgroundStyle;
